import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ShareDeviceLayout } from '@/components/layouts/ShareDeviceLayout';
import { ROUTE_PATH } from '@/constants/routes';

export const ShareDevice = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleReserveClick = () => {
    navigate(ROUTE_PATH.SHARE_DEVICE_TIME_SELECTION);
  };

  return (
    <ShareDeviceLayout>
      <div className="page page_f1">
        <main className="page__main">
          <div className="page__content">
            <section className="f1">
              <div className="f1__line">
                <div className="f1__inner">
                  <div className="f1__area">
                    <div className="f1__title">
                      <img
                        className="f1__title-img"
                        src="/F_1_LOUNGERESERVATION.png"
                        alt="LOUNGE RESERVATION"
                      />
                    </div>
                    <div className="f1__category">
                      <img
                        className="f1__category-img"
                        src="/F_1_Showerroom.png"
                        alt={t('shareDevice.subtitle')}
                      />
                    </div>
                    <div className="f1__cta">
                      <a className="f1__cta-link" onClick={handleReserveClick}>
                        {t('shareDevice.reserveButton')}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
    </ShareDeviceLayout>
  );
};
